<script lang="ts" setup>
import { ref, watch } from 'vue'
import { api } from '@/api'
import { $formatErrorMessage, $log, $requestId } from '@/helpers'
import { useLoadingStore, useToastStore } from '@/stores'
import { KS } from '@/kuaishou'
import { track } from '@/track'

const props = withDefaults(defineProps<{
  value: boolean
  closable?: boolean
  contentId: string
  chapterId: string
}>(), {
  closable: true,
})
const emit = defineEmits<{
  (event: 'input', value: boolean): void
  (event: 'cancel'): void
  (event: 'unlock'): void
  (event: 'close'): void
}>()

function onClose() {
  if (!props.closable)
    return
  emit('input', false)
  emit('close')
}

const { $toast } = useToastStore()
const { $showLoading, $hideLoading } = useLoadingStore()

const modal = ref(true)
const adVideoPlayer = ref(false)
const adVideoData = ref<{ sessionId: string; src: string; poster: string; isDownload: boolean; [key: string]: any }>({ sessionId: '', src: '', poster: '', isDownload: false })
async function onUnlock() {
  $log('Component: BizModalLocked', '#onUnlock')
  $showLoading()

  try {
    // Note: request api for check
    const { data } = await api.get('/kuaishou/member/getMemberInfo')
    if (!data.isCanUnlockChapter)
      return $toast('今日解锁已达上限')

    track('inspireVideo', { name: 'unlockChapter', type: 'start' })
    await KS.playAdVideo({
      type: 1,
      async success(data: any) {
        track('inspireVideo', { name: 'unlockChapter', type: 'end' })
        $log('Component: BizModalLocked', '#onUnlock ~> success', { data })
        const payload: PostKuaishouAdReportRequestBody = {
          requestId: $requestId(),
          contentId: props.contentId,
          chapterId: props.chapterId,
        }
        try {
          const { data, msg } = await api.post<any, PostKuaishouAdReportResponse>('/kuaishou/ad/report', payload)
          if (!data) // 解锁失败
            $toast(msg)

          $toast('看完广告视频, 成功解锁新章节')
          emit('unlock')
          emit('input', false)
        }
        catch (error: any) {
          $toast($formatErrorMessage(error))
        }
      },
      fail(error: any) {
        track('inspireVideo', { name: 'unlockChapter', type: 'cancel' })
        $log('Component: BizModalLocked', '#onUnlock ~> fail', { error })
        $toast('未看完视频，无法领取奖励')
        emit('cancel')
        emit('input', false)
      },
    })
    // modal.value = false
  }
  catch {}
  finally {
    $hideLoading()
  }
}

watch(() => [modal.value, adVideoPlayer.value], () => {
  if (!modal.value && !adVideoPlayer.value)
    emit('input', false)
})
</script>

<template>
  <portal to="root" :order="2">
    <transition name="fade">
      <BizTrackShow
        v-if="modal"
        name="readChapterLocked" type="modal"
        class="fixed inset-0 z-99"
      >
        <div class="fixed inset-0 bg-#000000B2" @click="onClose" />
        <div
          class="w-270px px-30px pt-50px pb-25px
            absolute top-1/2 left-1/2 -translate-1/2
            rounded-15px rounded-tr-50px bg-white z-100 relative
          "
        >
          <img class="w-125px absolute -top-62px right-0" src="@/assets/modal-label-locked.png">
          <div>
            <p class="text-#FF6E0F">
              后续内容更精彩
            </p>
            <p class="mt-2 font-bold text-xl">
              免费解锁后续章节
            </p>
          </div>
          <a
            class="mt-4 block w-full py-2 text-center text-white bg-primary rounded-full"
            @click="onUnlock"
          >
            观看视频，立即解锁
          </a>
        </div>
      </BizTrackShow>
    </transition>

    <!-- <BizAdVideoPlayer
      v-if="adVideoPlayer"
      v-model="adVideoPlayer" :session-id="adVideoData.sessionId"
      :src="adVideoData.src" :poster="adVideoData.poster" :caption="adVideoData.caption"
      :is-download="adVideoData.isDownload" :action-bar="adVideoData.actionBar" :action-bar-color="adVideoData.actionBarColor"
    /> -->
  </portal>
</template>
